// src/components/modals/EditBucketModal.jsx
import React, { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";

export default function EditBucketModal({
  show,
  onClose,
  bucket,
  onSave,
}) {
  const [name, setName] = useState("");
  const [retencaoAtiva, setRetencaoAtiva] = useState(false);
  const [retencaoDias, setRetencaoDias] = useState(0);
  const [privado, setPrivado] = useState(true);
  const [versionamento, setVersionamento] = useState(false);
  const [quota, setQuota] = useState("");

  useEffect(() => {
    if (bucket) {
      setName(bucket.name);
      setRetencaoAtiva(bucket.retencaoAtiva ?? false);
      setRetencaoDias(bucket.retencaoTempo ?? 0);
      setPrivado(bucket.privado ?? true);
      setVersionamento(bucket.versionamento ?? false);
      setQuota(bucket.quota ?? "");
    }
  }, [bucket]);

  const handleSubmit = () => {
    const updated = {
      name,
      retencaoAtiva,
      retencaoTempo: retencaoDias,
      privado,
      versionamento,
      quota: quota || null,
    };
    onSave(updated);
  };

  return (
    <Modal show={show} onHide={onClose} centered>
      <Modal.Header closeButton>
        <Modal.Title>Editar Bucket: {bucket?.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form>
          <Form.Group className="mb-3" controlId="bucketName">
            <Form.Label>Nome</Form.Label>
            <Form.Control
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              disabled
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="retencaoAtiva">
            <Form.Check
              type="switch"
              label="Retenção ativa"
              checked={retencaoAtiva}
              onChange={(e) => setRetencaoAtiva(e.target.checked)}
            />
          </Form.Group>

          {retencaoAtiva && (
            <Form.Group className="mb-3" controlId="retencaoDias">
              <Form.Label>Tempo de retenção (dias)</Form.Label>
              <Form.Control
                type="number"
                min={1}
                value={retencaoDias}
                onChange={(e) => setRetencaoDias(parseInt(e.target.value, 10))}
              />
            </Form.Group>
          )}

          <Form.Group className="mb-3" controlId="privado">
            <Form.Check
              type="switch"
              label={privado ? "Privado" : "Público"}
              checked={privado}
              onChange={(e) => setPrivado(e.target.checked)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="versionamento">
            <Form.Check
              type="switch"
              label={versionamento ? "Versionamento ON" : "Versionamento OFF"}
              checked={versionamento}
              onChange={(e) => setVersionamento(e.target.checked)}
            />
          </Form.Group>

          <Form.Group className="mb-3" controlId="quota">
            <Form.Label>Quota (ex: "10GB", deixe vazio para ilimitada)</Form.Label>
            <Form.Control
              type="text"
              placeholder="10GB ou 500MB"
              value={quota}
              onChange={(e) => setQuota(e.target.value)}
            />
          </Form.Group>
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          Cancelar
        </Button>
        <Button variant="primary" onClick={handleSubmit}>
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
